<div id="onboarding-subscription-page">

  <app-onboarding-stepper [currentStep]="3"></app-onboarding-stepper>
  <app-onboarding-header
    title="Étape 3 : Commande"
    content="">
  </app-onboarding-header>

  <ng-container *ngIf="subscriptions$ | async as subscriptions">
    <div id="container-subscription-cards">
      <ng-container *ngFor="let subscription of subscriptions.content">
        <app-onboarding-subscription-card [subscription]="subscription"
                                          [isSelected]="isSelected(subscription)"
                                          (selected)="onSubscriptionSelected(subscription)">
        </app-onboarding-subscription-card>
      </ng-container>
    </div>
  </ng-container>

  <div class="container-actions">
    <button mat-stroked-button (click)="previousStep()"
            class="base"
            type="button">
      Retour
    </button>
    <button mat-flat-button (click)="submit()"
            color="accent"
            type="submit"
            [disabled]="selectedSubscription === null">
      <div class="icon">
        Suivant <img ngSrc="assets/images/icons/white/arrow-right.svg" alt="Icon arrow right" width="24" height="24">
      </div>
    </button>
  </div>
</div>
